import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/performance/PageLoadTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/projects/ProjectsCategoriesStatic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/ProjectsPageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "/vercel/path0/frontend/src/components/ui/Skeleton.tsx");
